import { oroMxAssetPaths } from '@/shared/theme/oro-mx-home-data';

/** 源站 Image 加载/失败默认图：站点 logo（rule.website_mobile_logo）。 */
export const ORO_MX_SOURCE_PLACEHOLDER = oroMxAssetPaths.gamePlaceholder;

/** 源站分类网格 getGameList limit */
export const ORO_MX_CATEGORY_PAGE_SIZE = 18;

/** 源站推荐合集一页 9 格；无游戏时先铺默认图占位 */
export const ORO_MX_SECTION_SKELETON_SIZE = 9;

export function oroMxSectionSeeAllCount(loaded: number, nodeCount: number) {
  return loaded > 0 ? loaded : Math.max(0, nodeCount);
}

export function oroMxShouldBindCover(src: string, inView: boolean) {
  return Boolean(src) && inView;
}

export function oroMxShowCover(bound: boolean, loaded: boolean, failed: boolean) {
  return bound && loaded && !failed;
}

export function sliceOroMxVisibleGames<T>(games: readonly T[], visible: number) {
  return games.slice(0, Math.max(0, visible));
}

export function nextOroMxVisibleCount(
  current: number,
  total: number,
  pageSize = ORO_MX_CATEGORY_PAGE_SIZE,
) {
  if (total <= 0) return 0;
  return Math.min(total, Math.max(0, current) + pageSize);
}

export function canLoadMoreOroMxGames(visible: number, total: number) {
  return visible < total;
}

export type OroMxPagedList<T> = {
  games: T[];
  hasMore: boolean;
  loading: boolean;
  nextPageNo: number;
  total: number;
};

export function createOroMxPagedList<T>(): OroMxPagedList<T> {
  return { games: [], hasMore: true, loading: false, nextPageNo: 1, total: 0 };
}

export function mergeOroMxGamePage<T>(
  state: OroMxPagedList<T>,
  page: { hasMore: boolean; items: readonly T[]; pageNo: number; total: number },
): OroMxPagedList<T> {
  return {
    games: page.pageNo <= 1 ? [...page.items] : [...state.games, ...page.items],
    hasMore: page.hasMore,
    loading: false,
    nextPageNo: Math.max(1, page.pageNo) + 1,
    total: Math.max(0, page.total),
  };
}
